module.exports = __webpack_public_path__ + "img/72.8ea3192a.png";